import request from "../utils/request";

export async function getOrderLogs(payload) {
  return request.get("Cart/OrderLogs?", {
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      branchId: payload.branch != null || payload.branch != undefined ? payload.branch.id : null,
      productId: payload.product != null ? payload.product.id : null,
      extraId: payload.extra != null ? payload.extra.id : null,
      personalId: payload.personal != null ? payload.personal.id : null,
      orderId: payload.order != null ? (typeof payload.order === 'object' ? payload.order.id : payload.order) : null,
      paymentMethodId: payload.paymentMethod != null ? payload.paymentMethod.id : null,
      minPrice: payload.price != null ? payload.price.min : null,
      maxPrice: payload.price != null ? payload.price.max : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate.toDateString() : null,
      startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate.toDateString() : null,
      endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      isNavigatedByQuestion: payload.isNavigatedByQuestion,
      orderSourceType: payload.orderSourceType,
      isDiscountedOnly: payload.isDiscountedOnly === 'Sadece İndirim Yapılanlar',
      isPrivateCampaignGiftOnly: payload.isPrivateCampaignGiftOnly
    }
  });
}

export async function getOrderLogsExcel(payload) {
  return request.get("Cart/OrderLogsExcel?", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      branchId: payload.branch != null || payload.branch != undefined ? payload.branch.id : null,
      productId: payload.product != null ? payload.product.id : null,
      extraId: payload.extra != null ? payload.extra.id : null,
      personalId: payload.personal != null ? payload.personal.id : null,
      orderId: payload.order != null ? (typeof payload.order === 'object' ? payload.order.id : payload.order) : null,
      paymentMethodId: payload.paymentMethod != null ? payload.paymentMethod.id : null,
      minPrice: payload.price != null ? payload.price.min : null,
      maxPrice: payload.price != null ? payload.price.max : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate.toDateString() : null,
      startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate.toDateString() : null,
      endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      isNavigatedByQuestion: payload.isNavigatedByQuestion,
      orderSourceType: payload.orderSourceType,
      isDiscountedOnly: payload.isDiscountedOnly === 'Sadece İndirim Yapılanlar',
      isPrivateCampaignGiftOnly: payload.isPrivateCampaignGiftOnly
    }
  });
}

export async function getOrderLogsExcelForDealer(payload) {
  return request.get("Cart/OrderLogsForDealerExcel?", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      branchId: payload.branch != null || payload.branch != undefined ? payload.branch.id : null,
      productId: payload.product != null ? payload.product.id : null,
      extraId: payload.extra != null ? payload.extra.id : null,
      personalId: payload.personal != null ? payload.personal.id : null,
      orderId: payload.order != null ? (typeof payload.order === 'object' ? payload.order.id : payload.order) : null,
      paymentMethodId: payload.paymentMethod != null ? payload.paymentMethod.id : null,
      minPrice: payload.price != null ? payload.price.min : null,
      maxPrice: payload.price != null ? payload.price.max : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate.toDateString() : null,
      startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate.toDateString() : null,
      endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      isNavigatedByQuestion: payload.isNavigatedByQuestion,
      orderSourceType: payload.orderSourceType,
      isDiscountedOnly: payload.isDiscountedOnly === 'Sadece İndirim Yapılanlar',
      isPrivateCampaignGiftOnly: payload.isPrivateCampaignGiftOnly
    }
  });
}

export async function getOrderLogsForDealer(payload) {
  return request.get("Cart/OrderLogsForDealer?", {
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      branchId: payload.branch != null || payload.branch != undefined ? payload.branch.id : null,
      productId: payload.product != null ? payload.product.id : null,
      extraId: payload.extra != null ? payload.extra.id : null,
      personalId: payload.personal != null ? payload.personal.id : null,
      orderId: payload.order != null ? (typeof payload.order === 'object' ? payload.order.id : payload.order) : null,
      paymentMethodId: payload.paymentMethod != null ? payload.paymentMethod.id : null,
      minPrice: payload.price != null ? payload.price.min : null,
      maxPrice: payload.price != null ? payload.price.max : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate.toDateString() : null,
      startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate.toDateString() : null,
      endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      isNavigatedByQuestion: payload.isNavigatedByQuestion,
      orderSourceType: payload.orderSourceType,
      isDiscountedOnly: payload.isDiscountedOnly === 'Sadece İndirim Yapılanlar',
      isPrivateCampaignGiftOnly: payload.isPrivateCampaignGiftOnly
    }
  });
}

export async function getOrderEntries(payload) {
  return request.get("Cart/GetOrderById", {
    params: {
      orderId: payload
    }
  })
}

export async function changePaymentMethod(payload) {
  return request.post("Cart/ChangePaymentMethod", payload)
}
